__turbopack_context__.v({
  "blobDesktop": "EventsCalendarEmpty-module-scss-module__QbApUa__blobDesktop",
  "blobMobile": "EventsCalendarEmpty-module-scss-module__QbApUa__blobMobile",
  "content": "EventsCalendarEmpty-module-scss-module__QbApUa__content",
  "copy": "EventsCalendarEmpty-module-scss-module__QbApUa__copy",
  "title": "EventsCalendarEmpty-module-scss-module__QbApUa__title",
  "wrapper": "EventsCalendarEmpty-module-scss-module__QbApUa__wrapper",
});
